import { generateId } from '../../helpers/generateId'

export const PAGE_SCHEMA = config => {
  const defaultProps = { id: generateId(), route: '/', name: 'Página Inicial' }

  if (config && typeof config === 'object') {
    if (config.id && typeof config.id === 'string') Object.assign(defaultProps, { id: config.id })
    if (config.route && typeof config.route === 'string') Object.assign(defaultProps, { route: config.route })
    if (config.name && typeof config.name === 'string') Object.assign(defaultProps, { name: config.name })
  }

  return {
    id: `page-${defaultProps.id}`,
    route: defaultProps.route,
    name: defaultProps.name,
  }
}

export const beforeParseContent = target => {
  // console.log('parser...')
}

export const PAGE_SECTION = config => ({
  schema: PAGE_SCHEMA(config),
  beforeParse: beforeParseContent
})
